<template>
  <Catalogs
    title="Группы заявок"
    create-text="Новая группа"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'TaskGroupAdd'"
    :route-edit="'TaskGroupEdit'"
    :route-view="'TaskGroupView'"
    :route-path="'/task_groups'"
    :can-edit="canEditTaskGroups()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import Catalogs from "../Catalogs.vue";

export default {
  name: "TaskGroups",
  components: { Catalogs },
  mixins: [catalogs, permissions],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'task-group-id'
        },
        {
          key: 'name',
          label: 'Название',
          sortable: true,
        },
        {
          key: 'active',
          label: 'Активная',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: 'Действия',
          class: 'task-group-action'
        },
      ],
    };
  },
  methods: {
    async fetchData(data) {
      return await this.getTaskGroups(data);
    },
    canEditTaskGroups() {
      return this.hasPermission([PERM.CATALOG_TASK_GROUP_EDIT]);
    }
  }
}
</script>

<style>
.task-group-id {
  width: 60px;
  text-align: center;
}

.task-group-action {
  width: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/TaskGroups/TaskGroups.vue